(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu2"] && !Shopify.designMode) return;
  try {
    (function () {
  // Only run hover logic on desktop (989px+)
  if (window.innerWidth < 990) return;

  // Open dropdown on hover, close when mouse leaves
  document.querySelectorAll('.header__inline-menu header-menu details').forEach(function (details) {
    var timeout;

    // The <li> wraps header-menu, use it as the hover zone
    var item = details.closest('li');
    if (!item) return;

    item.addEventListener('mouseenter', function () {
      clearTimeout(timeout);
      // Close any other open dropdowns first
      document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach(function (other) {
        if (other !== details) other.removeAttribute('open');
      });
      details.setAttribute('open', '');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });

    item.addEventListener('mouseleave', function () {
      // Small delay so cursor can move into the panel without it closing
      timeout = setTimeout(function () {
        details.removeAttribute('open');
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 120);
    });

    // Prevent summary click from toggling (hover controls open state)
    details.querySelector('summary').addEventListener('click', function (e) {
      e.preventDefault();
    });
  });

  // Close all dropdowns when clicking anywhere outside the nav
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header__inline-menu')) {
      document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
